import React from 'react';
import { useFormContext } from 'react-hook-form';
import SectionTitle from '../../content/SectionTitle';
import LabeledTextbox from '../../input/LabeledTextbox';
import ToolTip from '../../content/ToolTip';

export const CVVUpdateSectionTestId = 'CVVUpdateSection-framework';

const CVVUpdateSectionWithFormContext: React.FC = () => {
  const {
    register,
    formState: { errors },
  } = useFormContext<{ cvv: string }>();

  const toolTipText =
    'Enter the security code on the back of your card. For Amex, on the front of your card.';

  return (
    <div data-testid={CVVUpdateSectionTestId}>
      <SectionTitle>Credit Card Security Code</SectionTitle>
      <LabeledTextbox
        name="cvv"
        label="Security Code"
        type="password"
        autoComplete="off"
        errorLabel={errors?.cvv?.message}
        register={register}
        maxLength={4}
        icon={
          <ToolTip
            tipText={toolTipText}
            yPosition="above"
            xPosition="left"
            isInputIcon
          />
        }
      />
    </div>
  );
};

export default CVVUpdateSectionWithFormContext;
